function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M-3-2h16v16H-3z"
}), React.createElement("path", {
  fill: "#B1B1B1",
  d: "M5 .5l5 2.75v5.5L5 11.5 0 8.75v-5.5z"
}));

var SvgBulletShape4 = function SvgBulletShape4(props) {
  return React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEwIDEyIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZD0iTS0zLTJoMTZ2MTZILTN6Ii8+CiAgICAgICAgPHBhdGggZmlsbD0iI0IxQjFCMSIgZD0iTTUgLjVsNSAyLjc1djUuNUw1IDExLjUgMCA4Ljc1di01LjV6Ii8+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgBulletShape4 as ReactComponent };